export const FOODS = {
  berries: { id: "berries", assetKey: "food-berries", points: 10, label: "Berries" },
  apple: { id: "apple", assetKey: "food-apple", points: 20, label: "Apple" },
  acorns: { id: "acorns", assetKey: "food-acorns", points: 30, label: "Acorns" },
  honey: { id: "honey", assetKey: "food-honey", points: 50, label: "Honey" },
  fish: { id: "fish", assetKey: "food-fish", points: 100, label: "Fish" },
} as const;

export type FoodId = keyof typeof FOODS;

export const FOOD_IDS = Object.keys(FOODS) as FoodId[];

export function getFoodPoints(id: FoodId): number {
  return FOODS[id].points;
}

export function isFoodId(value: string): value is FoodId {
  return value in FOODS;
}
